module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Sensory-Overload-2.ac6bb6ed.jpg";